import { bindActionCreators, compose } from 'redux'
import { connect } from 'react-redux'
import { withPlugin } from '@core/hoc/withPlugin'
import {
  setModal,
  createPlan,
  createCyclesPlan,
  setCalendarMultiSelect
} from '@app/ac'
import { openedManagerAssistantPlanning } from '@app/reducer/manager-assistant'

const mapStateToProps = ({ shifts, workspaces, workspaceId, templates, unavailabilities, positions, auth, calendar }) => {
  const ws = workspaces && workspaceId ? workspaces.find(ws => ws.id === workspaceId) : null
  return {
    shifts,
    templates,
    workspace: ws,
    workspaceId,
    auth,
    loadedPeriods: calendar?.loadedPeriods,
    unavailabilities,
    positions
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  setModal,
  openPlanning: openedManagerAssistantPlanning,
  setCalendarMultiSelect,
  createPlan,
  createCyclesPlan
}, dispatch)

export default (component) => {
  return compose(
    withPlugin,
    connect(mapStateToProps, mapDispatchToProps))(component)
}
